export default {
  REASON_INVALID_PAYMENT_STATUS: 'invalid payment status',
  REASON_PAYMENT_PROCESSING: 'payment processing',
  REASON_INVALID_PAYMENT_TYPE: 'invalid payment type',
  REASON_DISABLED_IN_GATE: 'disabled in gate',
  REASON_INVALID_WL_ID: 'invalid transaction wl id',
  REASON_INSUFFICIENT_PERMISSIONS: 'insufficient permissions',
} as const;
